<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table
        :headers="headers"
        :items="district_list"
        sort-by="name"
        class="elevation-1 mytable"
        dense
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>District</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              >
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add District</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-autocomplete :items="district_super_master_list" v-model="addedItem.district_super_master_list"
                            item-text="name" label="Select District" :rules="[(v) => !!v || 'required']"
                            return-object></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field
                            v-model.trim="editedItem.name"
                            persistent-hint
                            :disabled="editedIndex != -1"
                            :hint="
                              editedIndex == -1
                                ? 'For example :: Mumbai, Pune, Nagpur'
                                : 'noneditable'
                            "
                            :filled="editedIndex == -1 ? false : true"
                            label="Enter District"
                            :rules="[(v) => !!v || 'required']"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col >
                          <v-text-field label="District In Unicode" v-model="addedItem.district_super_master_list.unicode_name" v-if="editedIndex == -1"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field label="District In Unicode" v-model="editedItem.unicode_name" v-if="editedIndex != -1"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox
                            dense
                            v-model="editedItem.isactive"
                            color="success"
                            label="Active"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col v-if="editedIndex == -1">
                          <v-checkbox dense v-model="newdistrictcheckbox" color="success"
                            label="District not present in above list? Add new here..."></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1 && newdistrictcheckbox">
                          <v-text-field v-model="new_district" persistent-hint hint="For example :: Mumbai, Pune, Nagpur"
                            label="New District" ref="new-district"></v-text-field>
                        </v-col>
                        <v-col v-if="editedIndex == -1 && newdistrictcheckbox">
                          <v-text-field label="New District In Unicode" v-model="unicode_new_district"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="newdistrictcheckbox">
                          <v-btn class="mb-2 button" color="primary" small @click="saveNewDistrict">Save New District</v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close"
                      >Cancel</v-btn
                    >
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid"
                      >Save</v-btn
                    >
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success"
              >mdi-check-circle-outline</v-icon
            >
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error"
              >mdi-close-circle-outline</v-icon
            >
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
                >edit</v-icon
              >
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      name: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "District",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "District In Unicode",
        align: "left",
        sortable: false,
        value: "unicode_name",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    district_list: [],
    district_super_master_list:[],
    editedIndex: -1,
    editedItem: {
      districtId: "",
      name: "",
      unicode_name:"",
      isactive: true,
    },
    defaultItem: {
      districtId: "",
      name: "",
      unicode_name:"",
      isactive: true,
    },
    addedItem: {
      district_super_master_list:""
    },
    new_district:"",
    unicode_new_district:"",
    newdistrictcheckbox : false
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New District" : "Edit District";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.name = false;
    },
       hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/district")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.district_list = res.data.district_list;
              this.district_super_master_list = res.data.district_super_master_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.district_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/editDistrict", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.district_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "District Updated Successfully..."
                ); // show snackbar on success
                this.onLoad();
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
          axios
            .post("/AdmissionMaster/saveDistrict", this.addedItem)
            .then((res) => {
              if (res.data.status.code == "SUCCESS") {
                 if(this.hasWhiteSpace(this.name))
                this.district_list.push(this.editedItem);
                this.showSnackbar("#4caf50", "District Added Successfully..."); // show snackbar on success
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "District Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
      }
    }, // end of save()

    saveNewDistrict() {
      if (this.new_district.length == 0) {
        this.showSnackbar("#b71c1c", "Please add district!");
        this.$refs["new_district"].focus();
        return;
      }
      let data = {
        new_district: this.new_district,
        unicode_new_district : this.unicode_new_district
      };
      this.overlay = true;
      axios
        .post("/AdmissionMaster/addNewDistrict", data)
        .then((res) => {
            this.new_district = "",
            this.unicode_new_district = "",
            this.newdistrictcheckbox = false,
            this.overlay = false;
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "District Added Successfully!!!"); 
            this.onLoad();
          } else if (res.data.status.code == "NA") {
            this.showSnackbar("#b71c1c", "District Already Present!"); 
          }
        })
        .catch((error) => {
          this.overlay = false;
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
      this.close();
    },

    isValidated() {
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>